module.exports = __webpack_public_path__ + "790ae03e4a6ca434359ccf640efb0687.MP3";